export const COPOLIT_SOCKET_KEY = "CopilotSocket";
